export const LOGIN_ROUTES = {
    HOME: "/",
    RESET_PASSWORD: "/reset-password",
    USER_STATUS_UPDATE: `/link/status`,
    TENANT_LOGIN: "/login/:data",
};
export const MEETING_ROUTES = {
    JOIN_MEETING_HM: "/manager/join",
    JOIN_MEETING_HM_WITHOUT_MS_LOGIN: "/manager/nw",
    JOIN_MEETING_HM_AUTO_LOGIN: "/manager/nw-join",
    JOIN_MEETING_ADDITIONAL_HM: "/manager/additional/nw-join",
    JOIN_MEETING_CANDIDATE: "/:tenantName/candidate/join",
    JOIN_MEETING_NORMAL: "/join",
    JOIN_MEETING_SIMPLE: "/join-simple",
    JOIN_MEETING_CANDIDATE_URL_BASED: "/candidate",
    SCREEN_RECORDER: "/screen-recorder",
    ASSESSMENT_SETUP: "/assessment-setup",
    PROCTORED_INTERVIEW_GUIDELINES: "/proctored-interview-guidelines",
    FINISH_PAGE: "/finish-page",
};
export const MS_CALENDER_ROUTES = {
    LOGIN: "/ms-login",
};
export const MANAGER_MS_ROUTES = {
    LOGIN_INIT: "/manager-ms-login-init",
    LOGIN_CALLBACK: "/manager-ms-login-callback",
};
